import { createStyles } from '@mantine/core';

import { HEADER_HEIGHT } from '../../constants';

const useStyles = createStyles((theme) => ({
  userMenuBackdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: theme.other.zIndex.headerMenu - 1,
  },
  userMenuContainer: {
    position: 'fixed',
    top: HEADER_HEIGHT + 8,
    right: 16,
    zIndex: theme.other.zIndex.headerMenu,
    width: 350,
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.85)',
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
    boxShadow: '0 8px 40px 0 rgba(0, 0, 0, 0.10)',
    'backdrop-filter': 'blur(10px)',

    [theme.fn.smallerThan('sm')]: {
      position: 'fixed',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      width: '100%',
      height: '100%',
      'backdrop-filter': 'none',
      backgroundColor: theme.white,
      zIndex: theme.other.zIndex.mobileMenu,
      overflow: 'hidden',
    },
  },

  userMenuHeader: {
    position: 'absolute',
    top: 0,
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    padding: `14px ${theme.other.spacing._16}px`,
    justifyContent: 'space-between',
    gap: theme.other.spacing._4,
    zIndex: theme.other.zIndex.headerMenu + 1,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
    'backdrop-filter': 'blur(10px)',
  },
  closeButton: {
    marginLeft: 'auto',
    width: 28,
    height: 28,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 28,
    backgroundColor: theme.colors.gray[2],
    cursor: 'pointer',
    transition: 'background-color 0.2s ease-in-out',

    '&:hover': {
      backgroundColor: theme.colors.gray[3],
    },
  },
  userMenuContent: {
    position: 'relative',
    display: 'flex',
    flexFlow: 'column nowrap',
    justifyContent: 'space-between',
    height: '100%',
    padding: `${theme.other.spacing._8}px 0`,
    zIndex: theme.other.zIndex.headerMenu,

    [theme.fn.smallerThan('sm')]: {
      paddingTop: /* eslint-disable-line local-rules/use-theme-tokens */ 56,
      overflowY: 'auto',
    },
  },

  userDetailContainer: {
    display: 'block',
    padding: theme.other.spacing._16,
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
    textDecoration: 'none',

    [theme.fn.smallerThan('sm')]: {
      paddingTop: 0,
    },

    '&.isKYCverified': {
      paddingTop: theme.other.spacing._16,
      paddingBottom: theme.other.spacing._8,
    },
  },
  balanceWidgetContainer: {
    margin: `0 ${theme.other.spacing._8}px`,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 12,
    boxShadow: '0 8px 40px 0 rgba(0, 0, 0, 0.10)',
    backgroundColor: theme.white,

    '&.isKYCverified': {
      margin: `0 ${theme.other.spacing._16}px`,
      marginBottom: theme.other.spacing._16,
    },
  },

  userNavContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.other.spacing._8,
    paddingTop: theme.other.spacing._8,
    paddingBottom: theme.other.spacing._8,
    marginBottom: 'auto',

    [theme.fn.smallerThan('sm')]: {
      paddingTop: theme.other.spacing._8,
      gap: theme.other.spacing._12,
    },
  },
  userNavLinkContainer: {
    borderLeft: '3px solid transparent',
    padding: `0 ${theme.other.spacing._8}px`,

    '&.isActive': {
      borderLeft: `3px solid ${theme.colors.blue[7]}`,
    },
  },
  userNavDivider: {
    height: 1,
    backgroundColor: theme.colors.gray2[7],
    margin: `0 ${theme.other.spacing._8}px`,
    opacity: 0.1,
  },
  userNavLink: {
    width: '100%',
    padding: theme.other.spacing._8,
    textDecoration: 'none',
    color: theme.colors.gray2[6],
    borderRadius: theme.radius.sm,
    display: 'flex',
    alignItems: 'center',
    gap: theme.other.spacing._12,
    transition: 'background-color 0.2s ease-in-out',

    '&.isCritical': {
      color: theme.colors.red[6],
    },

    '&:hover': {
      backgroundColor: 'rgba(0, 0, 0, 0.05)',
    },
  },
  userNavLinkBadge: {
    minWidth: 20,
    height: 20,
    borderRadius: /* eslint-disable-line local-rules/use-theme-tokens */ 20,
    padding: /* eslint-disable-line local-rules/use-theme-tokens */ '0 4px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.red[6],
    marginLeft: -theme.other.spacing._6,
  },
}));

export default useStyles;
